/** @module MaterialSpec/MaterialPlanColorSpec */
define([
	"dojo/_base/declare",
	"csi/heading/Ref",
	"csi/xml",
	"./MaterialPlanColor"
], function(declare,Ref,xml,MaterialPlanColor) {

	return declare(MaterialPlanColor, {

		/**
		 * C8-9743 : Compare to Theme mode: display either MPPColorSpec or MPPColor if MPPColorSpec is not specified (or vice-versa).
		 * @param {Context} ctx
		 * @param {Heading) h
		 */
		_getValue: function(ctx, h) {
			var v = this.inherited(arguments);
			return ctx.view.compareToTheme && !xml.isValidURL(v) ? ctx.getNode().MPPColor : v;
		}

	});
});